import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
declare var UIkit: any;
import * as moment from 'moment';
import { ReservationsService } from '@app/shared/services/reservations.service';
import { DateService } from '@app/shared/services/date.service';
import { VehiclesService } from '@app/shared/services/vehicles.service';

@Component({
  selector: 'app-change-reservation-details',
  templateUrl: './change-reservation-details.component.html',
  styleUrls: ['./change-reservation-details.component.scss']
})
export class ChangeReservationDetailsComponent {

  /* Datepicker */

  public dateStart : string = '';
  public dateEnd : string = '';
  public hourStart : number = 0;
  public minuteStart : number = 0;
  public hourEnd : number = 0;
  public minuteEnd : number = 0;

  /* Estimates */

  public estimatedPeriod : any = {
    ISOEstimatedRealStartDate: "1970-01-01T00:00:00.0000000Z",
    ISOEstimatedRealEndDate: "1970-01-01T00:00:00.0000000Z"
  };
  public estimatedKm : number = 0;

  /* State */

  public km : number = 0;
  public loading : boolean = true;
  public loadingEstimation : boolean = false;
  public available : boolean = true;
  @Input() id: number = 0;
  @Input() reservation: any = {};
  @Output() changed = new EventEmitter();

  constructor(
    private reservationService: ReservationsService,
    private vehicleService: VehiclesService,
    private dateService: DateService
  ) {}

  ngOnChanges() {
    if (Object.keys(this.reservation).length === 0)
      return;
    this.loadInformations();
    this.loadEstimations();
  }

  loadInformations() : void {
    this.loading = true;
    // this.available = false;
    this.reservationService.getReservationCheckout(this.id).then((res) => {
      if (res !== null) {
        this.available = true;
        res = this.dateService.convertToLocal(res);
        this.km = res.realDistanceTraveled;
        this.dateStart = moment(res.ISORealDateStart).format('DD/MM/YYYY').split('T')[0];
        this.dateEnd = moment(res.ISORealDateEnd).format('DD/MM/YYYY').split('T')[0];
        this.hourStart = res.ISORealDateStart.split('T')[1].split('.')[0].split(':')[0];
        this.minuteStart = res.ISORealDateStart.split('T')[1].split('.')[0].split(':')[1];
        this.hourEnd = res.ISORealDateEnd.split('T')[1].split('.')[0].split(':')[0];
        this.minuteEnd = res.ISORealDateEnd.split('T')[1].split('.')[0].split(':')[1];
      }
      else
      {
        this.available = false;
      }
      this.loading = false;
    });
  }

  loadEstimations() : void {
    let dates : any = {};

    this.loadingEstimation = true;
    dates.start = moment(this.reservation.ISODateStart).format();
    dates.end = moment(this.reservation.ISODateEnd).format();
    dates = this.dateService.convertToLocal(dates);
    dates = this.dateService.convertToISO(dates);
    this.vehicleService.getVehicle(this.reservation.IdVehicle).then((vehicle) => {
      this.reservationService.getEstimatedRealPeriod(
        vehicle.idEquipment,
        dates.start,
        dates.end
      ).then((period) => {
        let datesPeriod : any = {};

        period = this.dateService.convertToLocal(period);
        this.estimatedPeriod = period;
        datesPeriod.start = moment(this.estimatedPeriod.ISOEstimatedRealStartDate).format();
        datesPeriod.end = moment(this.estimatedPeriod.ISOEstimatedRealEndDate).format();
        datesPeriod = this.dateService.convertToLocal(datesPeriod);
        datesPeriod = this.dateService.convertToISO(datesPeriod);
        this.reservationService.getEstimatedMileage(
          vehicle.idEquipment,
          (datesPeriod.start.includes('1970-01-01') === false) ? datesPeriod.start : dates.start,
          (datesPeriod.end.includes('1970-01-01') === false) ? datesPeriod.end : dates.end
        ).then((mileage) => {
          this.estimatedKm = mileage;
          this.loadingEstimation = false;
        });
      });
    })
  }

  formatHours(hour, minute) : string {
    let format = '';

    format += (hour < 10) ? '0' + parseInt(hour, 10) : parseInt(hour, 10);
    format += (minute < 10) ? ':' + '0' + parseInt(minute, 10) : ':' + parseInt(minute, 10);
    format += ':00.0000000Z';
    return format
  }

  updateCheckout() {
    let checkout = {
      IdGalagoBookingCheckout: 16,
      IdGalagoBooking: 105614,
      ISORealDateStart: moment(this.dateStart, 'DD/MM/YYYY').format().split('T')[0] + 'T' + this.formatHours(this.hourStart, this.minuteStart),
      ISORealDateEnd: moment(this.dateEnd, 'DD/MM/YYYY').format().split('T')[0] + 'T' + this.formatHours(this.hourEnd, this.minuteEnd),
      realDistanceTraveled: this.km,
      status: 0
    };

    checkout = this.dateService.convertToLocal(checkout);
    checkout = this.dateService.convertToISO(checkout);
    this.reservation.checkout = checkout;
    this.loading = true;
    this.reservationService.changeReservationCheckout(this.id, checkout).then((res) => {
      this.loading = false;
      this.changed.emit();
      UIkit.modal('#change-reservation-details').hide();
    });
  }

}
